import { render, staticRenderFns } from "./shouyi.vue?vue&type=template&id=6a2955b0&scoped=true"
import script from "./shouyi.vue?vue&type=script&lang=js"
export * from "./shouyi.vue?vue&type=script&lang=js"
import style0 from "./shouyi.vue?vue&type=style&index=0&id=6a2955b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2955b0",
  null
  
)

export default component.exports